import React from "react";
import { Button, Col, Row } from "reactstrap";

const CreateButtons = ({ resetForm }) => {
  return (
    <Row className="justify-content-between">
      <Col lg={6}>
        <Row>
          <Col lg={4}>
            <Button
              outline
              size="lg"
              className="ms-auto p-2 border-primary"
              color="primary"
              style={{ width: "100%" }}
            >
              Import Data
            </Button>
          </Col>
          <Col lg={4}>
            <Button
              outline
              size="lg"
              className="ms-auto p-2 border-primary"
              color="primary"
              style={{ width: "100%" }}
              onClick={resetForm}
            >
              Clear Data
            </Button>
          </Col>
        </Row>
      </Col>
      <Col lg={6}>
        <Row className="justify-content-end ">
          <Col xs={3} className="d-flex justify-content-end">
            <Button
              size="lg"
              className="ms-auto p-2 border-white"
              color="danger"
              type="submit"
              style={{ marginRight: "-20px" }}
            >
              Save as Draft
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CreateButtons;
